export declare type Patch<T> = Partial<{
  [P in keyof T]: Patch<T[P]>;
}>

export * from './NewWhiteboardTabMenuItem'
export * from './WhiteboardFlexLayoutTab'
export * from './WhiteboardRoot'
export * from './tools'
export * from './shapes'
export * from './sessions'
export * from './TLDR'
export * from './components'
export * from './useKeyboardShortcuts'
export * from './state'
export * from './WhiteboardContextMenu'
export * from './WhiteboardCameraStore'
export * from './WhiteboardSelectionStore'
export * from './WhiteboardToolStore'
export * from './types'
export * from './WhiteboardStore'
export * from './WhiteboardClipboardStore'
export * from './SelectedShapesDimensionsToolbar'
export * from './SelectedShapesFloatingToolbar'
export * from './ChooseShapePopoverContent'
export * from './WhiteboardPageStore'

export const fixNewLines = /\r?\n|\r/g

export const normalizeText = (text: string) => {
  return text.replace(fixNewLines, '\n')
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/index.ts